var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTdIconFastvanDisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9622",
    "data-name": "Rectangle 9622",
    width: 186,
    height: 186,
    transform: "translate(-0.218 -0.036)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(0.218 0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M186.01,93A93,93,0,1,1,93,0a93,93,0,0,1,93,93",
    transform: "translate(-0.116 0.061)",
    fill: "#f09337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M171.312,222.678h66.95v11.747H151.876V178.19H163.43V222.7Z",
    transform: "translate(-108.193 -126.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M203.795,216.621h30.17v30.158H223.637V234.622l-12.775,11.853-7.067-7.669,12.8-11.9h-12.8Z",
    transform: "translate(-145.139 -154.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M319.077,246.647l.192-.149-.192.146.022-1.005h0v-28.57h.044l-.042,0-.027-.7c19.47.251,19.039,14.173,18.977,15.249q.02.263.02.53a6.911,6.911,0,0,1-.07.985c-1.056,12.646-14.244,13.541-17.958,13.541-.613,0-.968-.025-.968-.025",
    transform: "translate(-227.175 -153.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M204.3,412.059a13.536,13.536,0,1,1,13.536-13.535A13.551,13.551,0,0,1,204.3,412.059m0-25.252a11.717,11.717,0,1,0,11.717,11.717A11.73,11.73,0,0,0,204.3,386.807",
    transform: "translate(-135.863 -273.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M437.249,412.059a13.536,13.536,0,1,1,13.536-13.535,13.551,13.551,0,0,1-13.536,13.535m0-25.252a11.717,11.717,0,1,0,11.717,11.717,11.73,11.73,0,0,0-11.717-11.717",
    transform: "translate(-301.636 -273.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M313.893,397.441a15.133,15.133,0,0,1,6.592-11.13h-48.4a15.131,15.131,0,0,1,6.593,11.145Z",
    transform: "translate(-193.733 -274.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M506.661,397.452a15.131,15.131,0,0,0-6.593-11.141h22.923a2.147,2.147,0,0,1,2.147,2.147v6.865a2.147,2.147,0,0,1-2.148,2.147Z",
    transform: "translate(-355.971 -274.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M156.511,397.464a15.13,15.13,0,0,1,6.594-11.152H149.337a2.207,2.207,0,0,0-2.207,2.207v6.745a2.207,2.207,0,0,0,2.208,2.207Z",
    transform: "translate(-104.816 -274.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M238.618,232.954h-1.089v-35.2c-.068-6.938-3.191-12.438-9.282-16.342a25.653,25.653,0,0,0-13.881-4.025H151.86V176.3h62.506a26.74,26.74,0,0,1,14.469,4.2c6.329,4.057,9.712,10.024,9.783,17.254Z",
    transform: "translate(-108.182 -125.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M494.98,239.89l-9.735-10.771a6.346,6.346,0,0,0-4.7-2.161H467.5a2.92,2.92,0,0,0-2.75,3.065V269.2h32.2V245.172a7.893,7.893,0,0,0-1.973-5.282m-3.359,6.171a.647.647,0,0,1-.647.647H470.732a.647.647,0,0,1-.647-.647V233.344a1.053,1.053,0,0,1,1.053-1.053h9.4a1.1,1.1,0,0,1,.748.4l9.735,10.771a2.6,2.6,0,0,1,.6,1.707Z",
    transform: "translate(-330.84 -161.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M483.833,304.821h10.3a.708.708,0,0,0,0-1.411h-10.3a.708.708,0,0,0,0,1.411",
    transform: "translate(-343.96 -215.849)",
    fill: "#f09337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M85.156,181.442H100.44a.721.721,0,1,0,0-1.442H85.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-60.201 -128.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M49.156,218.442H74.822a.721.721,0,1,0,0-1.442H49.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-34.583 -154.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M82.156,368.442H97.44a.721.721,0,1,0,0-1.442H82.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-58.066 -261.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M46.156,405.442H71.822a.721.721,0,1,0,0-1.442H46.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-32.448 -287.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M97.156,252.442H108.98a.721.721,0,0,0,0-1.442H97.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-68.741 -178.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M53.156,288.442H77.669a.721.721,0,1,0,0-1.442H53.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-37.43 -204.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M61.156,328.442H83.361a.721.721,0,1,0,0-1.442H61.156a.721.721,0,1,0,0,1.442",
    transform: "translate(-43.122 -232.636)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdIconFastvanDisk);
export default __webpack_public_path__ + "static/media/TD_Icon_Fastvan_Disk.14e7e34ca8b7aa5260d1a86d0945e1c6.svg";
export { ForwardRef as ReactComponent };